import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=585b943e&scoped=true&lang=html&"
import script from "./Browse.vue?vue&type=script&lang=ts&"
export * from "./Browse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b943e",
  null
  
)

export default component.exports